import { ScheduleTypeEnum } from '../enums/schedule-type.enum';

export class ScheduleBlock {
  id?: number;
  day?: string; //Remove 
  start?: string; //Remove 
  end?: string; //Remove 
  title?: string;
  description?: string;
  scheduleEntries: ScheduleBlockItem[];
  scheduleType?: ScheduleTypeEnum;
  classId?: number;
}

export class ScheduleBlockItem {
  id?: number;
  start: string;
  end: string;
  day: string;
  title?: string; //Remove 
  description?: string; //Remove 
  toDelete?: boolean;
  key?: string;

  constructor(data: any) {
    if (data) Object.assign(this, data);
  }
}

export class Placeholder {
  color: string;
  contentId?: number;
  contentTitle?: string;
  id: number;
  title: string;
  totalTime: number;
  teacher: {
    id: number;
    fullName: string;
  }
}

export class ScheduleEntry {
  id: number;
  title: string;
  description: string;
  startTime: string;
  endTime: string;
  placeholders: Placeholder[];
}

export class ScheduleClass {
  workingDay: string;
  entries: ScheduleEntry[];
}

export class ScheduleEntryCalendar {
  id: number;
  name: string;
  start: string;
  end: string;
  placeholders: Placeholder[];
  workingDay: string;
  scheduleBlockId: number;
  get duration(): number {
    const startDate = new Date(this.start);
    const endDate = new Date(this.end);
    return Math.round((endDate.getTime() - startDate.getTime()) / 60000);
  }
}

export class ScheduleDetails {
  [key: string]: {
    startTime: string;
    endTime: string;
    duration: number;
    placeholder: Placeholder;
    otherPlaceholder: Placeholder[];
    defaultPlaceholder: boolean;
  }[];
}

/* DTOs */
export class ScheduleResponseDto {
  entries: ScheduleEntriesResponseDto[];
  workingDay: string;

  static getScheduleBlocks(schedule: ScheduleResponseDto[]): ScheduleBlock[] {
    const scheduleBlocks: ScheduleBlock[] = [];

    schedule.forEach((schedule) => {
      schedule.entries.forEach((entry) => {
        const blockFound = scheduleBlocks.find((b) => b.id === entry.scheduleBlock.id);
        if (!blockFound) {
          scheduleBlocks.push({
            ...entry.scheduleBlock,
            scheduleEntries: [{
              id: entry.id,
              start: entry.startTime,
              end: entry.endTime,
              day: entry.workingDay,
            }],
          });
        } else {
          blockFound.scheduleEntries.push({
            id: entry.id,
            start: entry.startTime,
            end: entry.endTime,
            day: entry.workingDay,
          });
        }
      });
    });

    return scheduleBlocks;
  }
}

export class ScheduleEntriesResponseDto {
  id: number;
  endTime: string;
  startTime: string;
  workingDay: string;
  placeholders: any[];
  scheduleBlock: ScheduleBlock;
}

export class CreateScheduleBlockDto {
  title: string;
  description: string;
  scheduleEntries: any[];
  otherClasses?: number[];

  constructor(block: ScheduleBlock) {
    this.title = block.title;
    this.description = block.description;
    this.scheduleEntries = block.scheduleEntries.map(e => ({
      workingDay: e.key || e.day,
      startTime: e.start,
      endTime: e.end,
    }));
  }
}

export class ResponseCreateScheduleBlockDto {
  id: number;
  description: string;
  scheduleEntries: ScheduleEntriesResponseDto[];
  title: string;

  static getScheduleBlock(blockResponse: ResponseCreateScheduleBlockDto): ScheduleBlock {
    return {
      id: blockResponse.id,
      description: blockResponse.description,
      scheduleEntries: blockResponse.scheduleEntries.map((entry) => ({
        id: entry.id,
        day: entry.workingDay,
        start: entry.startTime,
        end: entry.endTime,
      })),
      title: blockResponse.title,
    };
  }
} 

export class UpdateScheduleBlockDto {
  id: number;
  title: string;
  description: string;
  scheduleEntries: any[];
  otherClasses?: number[];

  constructor(block: ScheduleBlock) {
    this.id = block.id;
    this.title = block.title;
    this.description = block.description;
    this.scheduleEntries = block.scheduleEntries.map(e => ({
      id: e.id,
      workingDay: e.day,
      startTime: e.start,
      endTime: e.end,
      toDelete: e.toDelete,
    }));
  }
}

export class ContentSchedule {
  id: number;
  workingDay: string;
  startTime: string;
  endTime: string;
  totalTime: number;
  defaultContentId: number;
  exceptionDates: Record<number, string[]>;
}

export class ScheduleTypeResponse{
  scheduleType	  : string;
  scheduleShortDay: string;
} 